import React, { FC } from 'react';
import styled from 'styled-components';
import { IconButtonRounded } from '../IconButtonRounded/IconButtonRounded';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { downloadFromUrl } from '../../../helpers';

interface WorkbookSampleDownloadProps {
  title?: string;
  downloadUrl: string | undefined;
}

const StyledWorkbookSampleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
  }
`;

export const WorkbookSampleDownload: FC<WorkbookSampleDownloadProps> = ({
  title = 'Download Workbook Sample',
  downloadUrl,
}) => {
  const handleDownloadWorkbook = () => {
    if (!downloadUrl) {
      console.error('Error downloading workbook sample: no download url provided');
      return;
    }
    downloadFromUrl(downloadUrl);
  };

  return (
    <StyledWorkbookSampleContainer>
      <h3>Download</h3>

      <IconButtonRounded title={title} icon={<CloudDownloadOutlinedIcon />} onClick={handleDownloadWorkbook} filled />
    </StyledWorkbookSampleContainer>
  );
};
